import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { map, catchError, of } from 'rxjs';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getToken();

  // Si no hay token, redirigir al login
  if (!token) {
    router.navigate(['/']);
    return false;
  }

  // Si el token no está expirado, permitir acceso
  if (!authService.isTokenExpired()) {
    return true;
  }

  // Si el token está expirado pero hay refresh token, intentar renovar
  if (authService.canRefreshToken()) {
    return authService.refreshAccessToken().pipe(
      map(() => true),
      catchError(() => {
        authService.logout();
        router.navigate(['/']);
        return of(false);
      })
    );
  }

  // Si no se puede renovar, cerrar sesión
  authService.logout();
  router.navigate(['/']);
  return false;
};
